import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  org_name = '';

  constructor() {

    this.org_name = window.localStorage['organisationName']
   }

  ngOnInit() {
  }

}





// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/about-us/about-us.component.ts